import { clsx, type ClassValue } from "clsx";
import { format, formatDistanceToNowStrict } from "date-fns";
import { es } from "date-fns/locale";

/* sin tailwind-merge: las clases son del template (Bootstrap), no de Tailwind */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

export function formatDate(value?: string | Date | null, withTime = false) {
  if (!value) return "-";
  const date = value instanceof Date ? value : new Date(value);
  return format(date, withTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy", {
    locale: es,
  });
}

export function dateInputValue(value?: string | Date | null) {
  if (!value) return "";
  return format(value instanceof Date ? value : new Date(value), "yyyy-MM-dd");
}

export function relativeDate(value?: string | Date | null) {
  if (!value) return "-";
  return formatDistanceToNowStrict(
    value instanceof Date ? value : new Date(value),
    {
      locale: es,
      addSuffix: true,
    },
  );
}

export function initials(firstName?: string, lastName?: string) {
  return `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase() || "US";
}

export function humanize(value: string) {
  return value
    .toLowerCase()
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/** 752 -> "12:32"; sirve para mostrar la duracion de un video. */
export function formatoDuracion(segundos: number) {
  if (!Number.isFinite(segundos) || segundos <= 0) return "--:--";
  const minutos = Math.floor(segundos / 60);
  return `${minutos}:${String(Math.round(segundos % 60)).padStart(2, "0")}`;
}
